import { WalletPinHttpProvider } from '../repository/wallet-pin-http-repository.provider';
import { WalletPinUseCasesProvider } from '../usecase/wallet-usecases.provider';

export const WalletPinModuleProvider = [...WalletPinUseCasesProvider, ...WalletPinHttpProvider];
